import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "Finally, I don't dread month-end.",
    name: "Rajesh S.",
    business: "Kirana Store",
    city: "Pune",
    avatar: "R",
  },
  {
    quote: "My CA was impressed. Bank loan approved in a week.",
    name: "Priya M.",
    business: "Beauty Parlour",
    city: "Hyderabad",
    avatar: "P",
  },
  {
    quote: "My staff enters sales. I see everything on my phone.",
    name: "Mohammed K.",
    business: "Restaurant",
    city: "Delhi",
    avatar: "M",
  },
  {
    quote: "Better than any notebook I've ever used.",
    name: "Sunita D.",
    business: "Tailoring Shop",
    city: "Mumbai",
    avatar: "S",
  },
];

export const TestimonialsSection = () => {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background to-secondary/20" />
      
      <div className="container relative z-10 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section header */}
          <div className="text-center space-y-4 mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20">
              <Quote className="h-4 w-4 text-accent" />
              <span className="text-sm font-medium text-accent">Owners Like You</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-balance px-2">
              From Kiranas to Cafés.
              <br />
              <span className="text-gradient">They All Close with KOSH.</span>
            </h2>
          </div>

          {/* Testimonials grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="group relative p-6 rounded-2xl bg-card border border-border hover:border-accent/30 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                {/* Quote icon */}
                <Quote className="h-8 w-8 text-accent/20 mb-4" />
                
                {/* Quote text */}
                <p className="text-base md:text-lg font-medium mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </p>
                
                {/* Author */}
                <div className="flex items-center gap-3">
                  {/* Avatar */}
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center text-primary-foreground font-bold text-sm">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <div className="font-medium text-sm">{testimonial.name}</div>
                    <div className="text-xs text-muted-foreground">
                      {testimonial.business}, {testimonial.city}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
